import { toast } from 'react-toastify';
import { buildLink, copyToClipboard, getBaseURL } from '@/components/util/all';

export const takePositionData = ({
  slug,
  matterId,
  sweep,
  rotation,
}: {
  slug: any;
  matterId: any;
  sweep: any;
  rotation: any;
}) => {
  const segmants = window.location.href.split('/');
  const id = segmants[segmants.length - 1].split('?')[0];
  if (slug === id || matterId === id) {
    copyToClipboard(buildLink(sweep, rotation));
  } else {
    const baseUrl = getBaseURL();
    const updatedUrl = baseUrl
      .split('/')
      .map((part, index, arr) => (index === arr.length - 1 ? slug : part))
      .join('/');
    const link = `${updatedUrl}?s=${sweep}&x=${rotation.x}&y=${rotation.y}`;
    copyToClipboard(link);
  }
  toast.success('Copied current position');
};
